<template>
  <div>
    <div class="card card-image" :style="{backgroundImage: 'url(' + require('../assets/images/ca/13.jpg') + ')'}"
         style="padding-bottom: 13em; padding-top: 5.2em; margin-bottom: 3em">
      <div class="px-4">
        <h1 class="h1-responsive font-weight-bolder mb-4    text-center white-text"
            style="text-shadow: 2px 2px 6px #000">
          加拿大移民</h1>
        <mdb-row center>
          <mdb-col md="10" xl="8">
            <div id="accordion">

              <div class="card opacityOuterCa animated rotateInUpLeft">
                <div class="card-header">
                  <a class="collapsed card-link  white-text " data-toggle="collapse" href="#collapseOne">
                    <i class="fab fa-canadian-maple-leaf card-header-icon"></i>雇主担保移民
                  </a>
                </div>
                <div id="collapseOne" class="collapse" data-parent="#accordion">
                  <div class="card-body">
                    BC省雇主担保移民、安省雇主担保移民、大西洋四省雇主担保移民。
                    <mdb-btn outline="danger" class="font-weight-bolder" size="sm" darkWaves
                             @click="$router.push('/ca/caguzhu')">了解详情
                    </mdb-btn>
                  </div>
                </div>
              </div>

              <div class="card opacityOuterCa animated rollIn">
                <div class="card-header">
                  <a class="collapsed card-link white-text" data-toggle="collapse" href="#collapseFive">
                    <i class="fab fa-canadian-maple-leaf card-header-icon"></i>曼省留学移民
                  </a>
                </div>
                <div id="collapseFive" class="collapse" data-parent="#accordion">
                  <div class="card-body">
                    保证工作机会，确保曼省省政府递交移民的资格, 整体申请时间较快,真实带薪工作，移民前可收入3万加币.
                    <mdb-btn outline="danger" class="font-weight-bolder" size="sm" darkWaves
                             @click="$router.push('/ca/caman')">了解详情
                    </mdb-btn>

                  </div>
                </div>
              </div>

              <div class="card opacityOuterCa  animated rotateInUpLeft">
                <div class="card-header">
                  <a class="collapsed card-link white-text " data-toggle="collapse" href="#collapseTwo">
                    <i class="fab fa-canadian-maple-leaf card-header-icon"></i>魁省投资移民
                  </a>
                </div>
                <div id="collapseTwo" class="collapse" data-parent="#accordion">
                  <div class="card-body">
                    没有学历、语言硬性要求，无需自营生意，一步到位获枫叶卡。
                    <mdb-btn outline="danger" class="font-weight-bolder" size="sm" darkWaves
                             @click="$router.push('/ca/cakui')">了解详情
                    </mdb-btn>

                  </div>
                </div>
              </div>

              <div class="card opacityOuterCa  animated rollIn">
                <div class="card-header">
                  <a class="collapsed card-link white-text " data-toggle="collapse" href="#collapseTwoExtra">
                    <i class="fab fa-canadian-maple-leaf card-header-icon"></i>联邦创业移民(SUV)
                  </a>
                </div>
                <div id="collapseTwoExtra" class="collapse" data-parent="#accordion">
                  <div class="card-body">
                    申请流程简单，无需省里审批、一步到位获得永居。
                    <mdb-btn outline="danger" class="font-weight-bolder" size="sm" darkWaves
                             @click="$router.push('/ca/casuv')">了解详情
                    </mdb-btn>

                  </div>
                </div>
              </div>

              <div class="card opacityOuterCa  animated rotateInUpLeft">
                <div class="card-header">
                  <a class="collapsed card-link white-text" data-toggle="collapse" href="#collapseThree">
                    <i class="fab fa-canadian-maple-leaf card-header-icon"></i>BC省企业家移民试点
                  </a>
                </div>
                <div id="collapseThree" class="collapse" data-parent="#accordion">
                  <div class="card-body">
                    史上要求最低,全家移民仅需10万加币!
                    <mdb-btn outline="danger" class="font-weight-bolder" size="sm" darkWaves
                             @click="$router.push('/ca/cabc')">了解详情
                    </mdb-btn>
                  </div>
                </div>
              </div>

              <div class="card opacityOuterCa  animated rollIn">
                <div class="card-header">
                  <a class="collapsed card-link white-text" data-toggle="collapse" href="#collapseFour">
                    <i class="fab fa-canadian-maple-leaf card-header-icon"></i>萨省企业家移民
                  </a>
                </div>
                <div id="collapseFour" class="collapse" data-parent="#accordion">
                  <div class="card-body">
                    资产要求低，投资成本少,申请门槛低，项目周期短.
                    <mdb-btn outline="danger" class="font-weight-bolder" size="sm" darkWaves
                             @click="$router.push('/ca/casa')">了解详情
                    </mdb-btn>

                  </div>
                </div>
              </div>


              <div class="card opacityOuterCa  animated rotateInUpLeft">
                <div class="card-header">
                  <a class="collapsed card-link white-text" data-toggle="collapse" href="#collapseSix">
                    <i class="fab fa-canadian-maple-leaf card-header-icon"></i>联邦自雇移民
                  </a>
                </div>
                <div id="collapseSix" class="collapse" data-parent="#accordion">
                  <div class="card-body">
                    加拿大高性价比移民捷径，平凡岗位也能走这条“明星路”。
                    <mdb-btn outline="danger" class="font-weight-bolder" size="sm" darkWaves
                             @click="$router.push('/ca/cazigu')">了解详情
                    </mdb-btn>

                  </div>
                </div>
              </div>

            </div>
          </mdb-col>
        </mdb-row>
      </div>
    </div>
  </div>


</template>

<script>
import { mdbAccordion, mdbRow, mdbCol } from 'mdbvue'
import 'mdbvue/lib/css/mdb.min.css'

export default {
  name: 'CaIndex',
  components: {
    mdbAccordion,
    mdbRow,
    mdbCol
  },
  data () {
    return {
      panes: [
        {
          title: '雇主担保移民',
          icon: 'book',
          content: `<div onclick="window.location.href='/#/usa/eb5'">了解详情</div>`
        },
        {
          title: '魁省投资移民',
          icon: `pen`,
          content: `<p class="p-md-4 mb-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute,
                                            non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch
                                            3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda
                                            shoreditch et.</p>`
        },
        {
          title: '联邦创业移民(SUV)',
          icon: `pen`,
          content: `<p class="p-md-4 mb-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute,
                                            non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch
                                            3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda
                                            shoreditch et.</p>`
        },
        {
          title: 'BC省企业家移民试点',
          icon: 'star',
          content: `<p class="p-md-4 mb-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute,
                                            non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch
                                            3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda
                                            shoreditch et.</p>`
        },
        {
          title: '萨省企业家移民',
          icon: 'star',
          content: `<p class="p-md-4 mb-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute,
                                            non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch
                                            3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda
                                            shoreditch et.</p>`
        },
        {
          title: '曼省留学移民',
          icon: 'star',
          content: `<p class="p-md-4 mb-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute,
                                            non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch
                                            3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda
                                            shoreditch et.</p>`
        },
        {
          title: '联邦自雇移民',
          icon: 'star',
          content: `<p class="p-md-4 mb-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute,
                                            non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch
                                            3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda
                                            shoreditch et.</p>`
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.opacityOuterCa {
  background: rgba(0, 0, 0, 0) !important;
  background: #000;
  filter: Alpha(opacity=0);
  color: white;
}

.card-header {
  font-weight: bold;
  border-bottom: 1px white dotted;
  font-size: larger;
  text-shadow: 2px 2px 6px #000
}

.card-body {
  /*font-weight: bold;*/
  color: black;
  margin: auto;
  width: 96%;
  background: rgba(255, 255, 255, 0.9) !important;

  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
  text-align: justify !important;
}

.card-header-icon {
  color: #ff4444;
  text-shadow: none;
  margin-right: 0.3em;
}
</style>
